import {Field, Form, FormikErrors, FormikProps, withFormik} from 'formik';
import * as React from 'react';
import Recaptcha from 'react-recaptcha';
import {IContactFormExtendedProps} from './contact-form';
import {createKasHelpDeskFormEntityAsync} from "../../actions/DataActionExtension.g";
import {IActionContext} from '@msdyn365-commerce/core-internal';
import {IFormRequestType} from "../../interfaces/FormRequestType";
import {Node } from '@msdyn365-commerce-modules/utilities';
interface IFormValues {
  name: string;
  email: string;
  company: string;
  city: string;
  state: string;
  country: string;
  phone: string;
  businessType: string;
  inquiry: string;
  reCaptcha: string;
  reCaptchaKey: string;
  site: string;
  requestType: IFormRequestType;
}

interface IContactFormProps {
  actionContext: IActionContext;
  site: string | undefined;
  recaptchaKey: string | undefined;
  handleSubmitStatusMessage(isSuccess: boolean):void;
  handleResetStatusMessage():void;
}

// tslint:disable-next-line: max-func-body-length
const InnerForm = (props: FormikProps<IFormValues>) => {
  const { touched, errors, isSubmitting } = props;
  const verifyCallback = (response: string) => {
    props.values.reCaptcha = response;
};

  return (
    <Form translate='false'>
      <div className='col-sm-12 col-md-6 fg'>
        <label htmlFor='name' className='required'>Name</label>
        <Field id='name' name='name' />
        {touched.name && errors.name && <div className='error'>{errors.name}</div>}
      </div>
      <div className='col-sm-12 col-md-6 fg'>
        <label htmlFor='email' className='required'>Email Address</label>
        <Field
          id='email'
          name='email'
          type='email'
        />
        {touched.email && errors.email && <div className='error'>{errors.email}</div>}
      </div>

      <div className='col-sm-12 col-md-6 fg'>
        <label htmlFor='company'>Company Name</label>
        <Field
          id='company'
          name='company'
        />
      </div>
      <div className='col-sm-12 col-md-6 fg'>

        <label htmlFor='phone' className='required'>Phone</label>
        <Field
          id='phone'
          name='phone'
          type='tel'
        />
        {touched.phone && errors.phone && <div className='error'>{errors.phone}</div>}

      </div>
      <div className='col-sm-12 col-md-4 fg'>

        <label htmlFor='city' className='required'>City</label>
        <Field
          id='city'
          name='city'
        />
        {touched.city && errors.city && <div className='error'>{errors.city}</div>}

      </div>
      <div className='col-sm-12 col-md-4 fg'>

        <label htmlFor='state' className='required'>State/Province</label>
        <Field
          id='state'
          name='state'
        />
        {touched.state && errors.state && <div className='error'>{errors.state}</div>}

      </div>
      <div className='col-sm-12 col-md-4 fg'>

        <label htmlFor='country' className='required'>Country</label>
        <Field
          id='country'
          name='country'
        />
        {touched.country && errors.country && <div className='error'>{errors.country}</div>}

      </div>

      <div className='col-sm-12 col-md-12 fg'>
            <label htmlFor='businessType'>Which of these best describes your business?</label>
            <Field component='select' id='businessType' name='businessType' multiple={false}>
              <option value='grocery' aria-selected selected>Grocery Store/Supermarket</option>
              <option value='butcher' aria-selected='false'>Butcher Shop</option>
              <option value='bakery' aria-selected='false'>Bakery</option>
              <option value='deli' aria-selected='false'>Deli</option>
              <option value='meatprocessor' aria-selected='false'>Meat Processor</option>
              <option value='sawmill' aria-selected='false'>Saw Mill</option>
              <option value='consumer' aria-selected='false'>Consumer/Individual</option>
              <option value='other' aria-selected='false'>Other</option>
            </Field>
      </div>

      <div className='col-sm-12 fg'>
        <label htmlFor='inquiry'>Which products or services are you interested in?</label>
        <Field component='textarea' id='inquiry' name='inquiry' />
      </div>
      {props.values.reCaptchaKey !== '' &&
      <div className='col-sm-12 fg'>
      <br/>

      <Recaptcha
        sitekey={props.values.reCaptchaKey}
        render='explicit'
        theme='light'
        verifyCallback={verifyCallback}
      />
      {touched.reCaptcha && errors.reCaptcha && <div className='error'>{errors.reCaptcha}</div>}

      </div>}
      <div className='col-sm-12 fg'>
        <button className='msc-cta__primary' type='submit' disabled={isSubmitting}>Submit</button>

      </div>
    </Form>
  );
};

const ContactForm = withFormik<IContactFormProps, IFormValues>({
  mapPropsToValues: props => {
    return {
      name: '',
      email: '',
      company: '',
      phone: '',
      city: '',
      state: '',
      country: '',
      businessType: 'grocery',
      inquiry: '',
      reCaptcha: '',
      reCaptchaKey: '',
      site: props.site || '',
      requestType: IFormRequestType.Contact
    };
  },
  validate: (values: IFormValues) => {
    const phonetest = /^[0-9+\(\)#\.\s\/ext-]+$/;
    const emailtest = /\S+@\S+\.\S+/;

    const errors: FormikErrors<IFormValues> = {};

    if (values.reCaptchaKey !== '' && !values.reCaptcha) {
      errors.reCaptcha = 'Required';
    }

    if (!values.email) {
      errors.email = 'Required';
    } else if (!emailtest.test(values.email)) {
      errors.email = 'Invalid email address';
    }

    if (!values.phone) {
      errors.phone = 'Required';
    } else if (!phonetest.test(values.phone)) {
      errors.phone = 'Invalid phone number';
    }

    if (!values.name) {
      errors.name = 'Required';
    }

    if (!values.city) {
      errors.city = 'Required';
    }

    if (!values.state) {
      errors.state = 'Required';
    }

    if (!values.country) {
      errors.country = 'Required';
    }

    return errors;
  },

  handleSubmit: async (values, formikbag) => {
    await createKasHelpDeskFormEntityAsync(
        {callerContext: formikbag.props.actionContext},
        values.name,
        values.email,
        values.company,
        values.phone,
        values.city,
        values.state,
        values.country,
        values.businessType,
        values.inquiry,
        values.site,
        String(values.requestType)
    );
    formikbag.resetForm();
    formikbag.props.handleSubmitStatusMessage(true);
    formikbag.setSubmitting(false);
    setTimeout(() => {
      formikbag.props.handleResetStatusMessage()
    }, 1000 * 15)





  }
})(InnerForm);

const ContactFormView: React.FC<IContactFormExtendedProps> = (props) => {
  const [isSuccess , setIsSuccess] = React.useState<boolean>(false);
  const [isFailure , setIsFailure] = React.useState<boolean>(false);
  const handleSubmitStatusMessage = (isSuccess: boolean) => {
    if (isSuccess) {
      setIsSuccess(true);
      setIsFailure(false);
    } else {
      setIsFailure(true);
      setIsSuccess(false);
    }
  }
  const handleResetStatusMessage = () => {
    setIsSuccess(false);
    setIsFailure(false);
  }
  const{textBox}=props;
  return (<>
    <div className='contact-form'>
      <h1>Contact Us</h1>
      <br />
      <Node className="contact-form-richtext">
        {textBox}
      </Node>
      {isSuccess ? <div className={'msc-alert msc-alert-success'}>{props.config.successMessage}</div> : null}
      {isFailure ? <div className="msc-alert msc-alert-danger">There was an error. Please try again.</div> : null}
      <ContactForm
          actionContext={props.context.actionContext}
          site={props.config.site}
          recaptchaKey={props.config.captchaKey}
          handleResetStatusMessage={handleResetStatusMessage}
          handleSubmitStatusMessage={handleSubmitStatusMessage}
      />
    </div>
  </>)
};

export default ContactFormView;